import * as ambassadorWixInfraAsyncjobsV1AsyncJob from './infra-asyncjobs-v1-async-job-async-jobs.http.js';
import * as ambassadorWixInfraAsyncjobsV1AsyncJobTypes from './infra-asyncjobs-v1-async-job-async-jobs.types.js';
import * as ambassadorWixInfraAsyncjobsV1AsyncJobUniversalTypes from './infra-asyncjobs-v1-async-job-async-jobs.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getAsyncJob(): __PublicMethodMetaInfo<
  'GET',
  { jobId: string },
  ambassadorWixInfraAsyncjobsV1AsyncJobUniversalTypes.GetAsyncJobRequest,
  ambassadorWixInfraAsyncjobsV1AsyncJobTypes.GetAsyncJobRequest,
  ambassadorWixInfraAsyncjobsV1AsyncJobUniversalTypes.GetAsyncJobResponse,
  ambassadorWixInfraAsyncjobsV1AsyncJobTypes.GetAsyncJobResponse
> {
  const payload = { jobId: ':jobId' } as any;

  const getRequestOptions =
    ambassadorWixInfraAsyncjobsV1AsyncJob.getAsyncJob(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/async-jobs/{jobId}',
    pathParams: { jobId: 'jobId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listAsyncJobItems(): __PublicMethodMetaInfo<
  'GET',
  { jobId: string },
  ambassadorWixInfraAsyncjobsV1AsyncJobUniversalTypes.ListAsyncJobItemsRequest,
  ambassadorWixInfraAsyncjobsV1AsyncJobTypes.ListAsyncJobItemsRequest,
  ambassadorWixInfraAsyncjobsV1AsyncJobUniversalTypes.ListAsyncJobItemsResponse,
  ambassadorWixInfraAsyncjobsV1AsyncJobTypes.ListAsyncJobItemsResponse
> {
  const payload = { jobId: ':jobId' } as any;

  const getRequestOptions =
    ambassadorWixInfraAsyncjobsV1AsyncJob.listAsyncJobItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/async-jobs/{jobId}/items',
    pathParams: { jobId: 'jobId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  AsyncJob as AsyncJobOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  AnonymousVisitorIdOptions as AnonymousVisitorIdOptionsOriginal,
  MemberIdOptions as MemberIdOptionsOriginal,
  WixUserIdOptions as WixUserIdOptionsOriginal,
  AppIdOptions as AppIdOptionsOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  Counters as CountersOriginal,
  Owner as OwnerOriginal,
  OwnerIdOneOf as OwnerIdOneOfOriginal,
  CreatedBy as CreatedByOriginal,
  CreatedByOptionsOneOf as CreatedByOptionsOneOfOriginal,
  Counts as CountsOriginal,
  AsyncJobFinishedEvent as AsyncJobFinishedEventOriginal,
  AsyncJobFailedEvent as AsyncJobFailedEventOriginal,
  AsyncJobItemFailedEvent as AsyncJobItemFailedEventOriginal,
  AsyncJobItem as AsyncJobItemOriginal,
  ApplicationError as ApplicationErrorOriginal,
  CreateAsyncJobRequest as CreateAsyncJobRequestOriginal,
  CreateAsyncJobResponse as CreateAsyncJobResponseOriginal,
  GetAsyncJobRequest as GetAsyncJobRequestOriginal,
  GetAsyncJobResponse as GetAsyncJobResponseOriginal,
  UpdateAsyncJobRequest as UpdateAsyncJobRequestOriginal,
  UpdateAsyncJobResponse as UpdateAsyncJobResponseOriginal,
  DeleteAsyncJobRequest as DeleteAsyncJobRequestOriginal,
  DeleteAsyncJobResponse as DeleteAsyncJobResponseOriginal,
  CompleteAsyncJobRequest as CompleteAsyncJobRequestOriginal,
  CompleteStatus as CompleteStatusOriginal,
  CompleteStatusWithLiterals as CompleteStatusWithLiteralsOriginal,
  CompleteAsyncJobResponse as CompleteAsyncJobResponseOriginal,
  ReportAsyncJobProgressRequest as ReportAsyncJobProgressRequestOriginal,
  ReportAsyncJobProgressResponse as ReportAsyncJobProgressResponseOriginal,
  AsyncJobItemAddedEvent as AsyncJobItemAddedEventOriginal,
  ListAsyncJobItemsRequest as ListAsyncJobItemsRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  StatusFilter as StatusFilterOriginal,
  StatusFilterWithLiterals as StatusFilterWithLiteralsOriginal,
  ListAsyncJobItemsResponse as ListAsyncJobItemsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './infra-asyncjobs-v1-async-job-async-jobs.types.js';
